module.exports = __webpack_public_path__ + "img/train_of_thought.ace01404.jpg";